var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReportFinCen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D8F4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1871 25.9267C27.5762 25.9267 27.8915 26.2681 27.8915 26.6897C27.8915 27.111 27.5764 27.4524 27.1871 27.4524H22.7725C22.3834 27.4524 22.0681 27.111 22.0681 26.6897C22.0681 26.2681 22.3834 25.9267 22.7725 25.9267H27.1871ZM27.1871 18.7809C27.5762 18.7809 27.8915 19.1223 27.8915 19.5437C27.8915 19.9652 27.5764 20.3066 27.1871 20.3066H22.7725C22.3834 20.3066 22.0681 19.965 22.0681 19.5437C22.0681 19.1223 22.3834 18.7809 22.7725 18.7809H27.1871ZM28.8778 22.468C29.2669 22.468 29.5822 22.8096 29.5822 23.2309C29.5822 23.6523 29.2669 23.9939 28.8778 23.9939H22.7725C22.3834 23.9939 22.0681 23.6523 22.0681 23.2309C22.0681 22.8096 22.3834 22.468 22.7725 22.468H28.8778ZM32.0713 14C32.4603 14 32.7758 14.3414 32.7758 14.763V28.5204C32.7758 30.3993 31.364 31.9279 29.6291 31.9279H18.0063C17.891 31.9445 17.7732 31.9532 17.6534 31.9532C16.1902 31.9532 15 30.6642 15 29.0797V24.8331C15 23.2488 16.1902 21.9594 17.6534 21.9594H18.898V14.763C18.898 14.3414 19.2133 14 19.6024 14H32.0713ZM18.898 29.0797V23.4852H17.6536C16.9673 23.4852 16.4089 24.0899 16.4089 24.8331V29.0797C16.4089 29.8227 16.9671 30.4274 17.6536 30.4274V30.4021H17.8944C18.4657 30.2802 18.898 29.7335 18.898 29.0797ZM31.3669 28.5204V15.5258H20.3069V29.0797C20.3069 29.5563 20.1993 30.0061 20.0089 30.4021H29.6291C30.5714 30.4021 31.3669 29.5403 31.3669 28.5204Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportFinCen);
export default __webpack_public_path__ + "static/media/ic-report-finCEN.8eb54371.svg";
export { ForwardRef as ReactComponent };